<template>
  <v-dialog v-model="dialog" max-width="500">
    <box :title="title">
      <div class="px-3 py-1">{{ message }}</div>
    </box>
  </v-dialog>
</template>

<script>
import Box from "./Box.vue";
export default {
  components: { Box },
  data() {
    return {
      dialog: false,
      message: "",
      title: "",
    };
  },
  methods: {
    show(title = "", msg = "") {
      this.dialog = true;
      this.message = msg;
      this.title = title;
    },
  },
};
</script>

<style>
</style>